import { useState } from "react";

import { useAuth } from "../auth/AuthProvider";
import { errorMessage } from "../components/ErrorAlert";

const NAME_RULE = "이름은 2~30자로 입력해 주세요.";

export const NameSetupPage = () => {
  const auth = useAuth();
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  return (
    <section className="canvaschool-auth">
      <h1>이름을 알려 주세요</h1>
      <p>선생님이 알아볼 수 있도록 내 이름을 적어 주세요.</p>
      <form
        aria-label="이름 입력"
        className="canvaschool-form"
        onSubmit={async (event) => {
          event.preventDefault();
          const name = value.trim().normalize("NFC");
          const length = [...name].length;
          if (length < 2 || length > 30) {
            setError(NAME_RULE);
            return;
          }
          setPending(true);
          setError(null);
          try {
            auth.updateStudentProfile(await auth.api.setDisplayName(name));
          } catch (failure) {
            const code = auth.handleError(failure);
            if (code === "CONFLICT") {
              // The teacher saved a name first; the reloaded session has it.
              await auth.reloadSession();
            }
            setError(errorMessage(code));
            setPending(false);
          }
        }}
      >
        <div className="canvaschool-field">
          <label htmlFor="canvaschool-display-name">이름</label>
          <input
            id="canvaschool-display-name"
            placeholder="김철수"
            autoComplete="name"
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
        </div>
        {error && (
          <p className="canvaschool-error--box canvaschool-error" role="alert">
            {error}
          </p>
        )}
        <button
          type="submit"
          className="canvaschool-btn-primary"
          disabled={pending}
        >
          저장
        </button>
      </form>
    </section>
  );
};
